<template>
  <div :class="$style['page-not-found']">
    <img src="https://static001.geekbang.org/resource/image/ca/5f/ca54b9dfdfa46be6529f25bc5e6f455f.png" alt="404" />
    <p>很抱歉，您访问的页面不存在</p>
    <gkButton
      :class="$style['return-btn']"
      :label="`${n} 秒后返回首页`"
      @click="handleGoHome"
    />
  </div>
</template>

<script>
import gkButton from 'gkui/button'

export default {
  name: 'not-found',
  components: {
    gkButton
  },
  data () {
    return {
      n: 3
    }
  },
  computed: {
  },
  created () {
  },
  mounted () {
    this.loop()
  },
  methods: {
    loop () {
      if (this.n < 1) {
        this.handleGoHome()
        return
      }

      setTimeout(() => {
        this.n--
        this.loop()
      }, 1000)
    },
    handleGoHome () {
      window.location.href = '/'
    }
  }
}
</script>

<style lang="scss" module>
@import '../style/bulma/app.sass';

.page-not-found {
  flex: 1;
  @include flexCenter;
  flex-direction: column;
  background: #F6F7F9;

  & img {
    display: block;
    width: 190px; height: 165px;
    margin-top: 84px;
  }

  & p {
    padding: 48px 0 24px;
    font-size: 14px; font-weight: 400;
    line-height: 1;
    color: #AEB9C4;
  }

  & .return-btn {
    width: 135px; height: 30px;
    margin-bottom: 48px;
    font-size: 14px;
    background: #D1A75F;
    color: #fff;
    border-radius: 3px;
  }
}
</style>
